import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Modules
import token from "./modules/token";

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    token
  },
  strict: debug,
  plugins: [
  ]
});

export default store;
